module.exports = __webpack_public_path__ + "img/contracts.9ce5a324.svg";